import { DISCIPLINES } from './constants';

export const DEFAULT_CLASS_IMAGE = 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?auto=format&fit=crop&w=1600&q=80';

const WEEK_ORDER = [1, 2, 3, 4, 5, 6, 0];

export async function fetchPublicDirectory() {
  const [creatorsRes, catalogRes, metaRes] = await Promise.all([
    fetch('/api/fit-live/public/creators').then((r) => (r.ok ? r.json() : Promise.reject(new Error('creators')))),
    fetch('/api/fit-live/public/catalog?discipline=all').then((r) => (r.ok ? r.json() : Promise.reject(new Error('catalog')))),
    fetch('/api/fit-live/public/meta').then((r) => (r.ok ? r.json() : {})).catch(() => ({})),
  ]);
  return {
    creators: creatorsRes.creators || [],
    classes: catalogRes.classes || [],
    replays: catalogRes.replays || [],
    supportWhatsapp: String(metaRes.support_whatsapp || '').trim(),
  };
}

export function disciplineLabel(id) {
  return DISCIPLINES.find((d) => d.id === id)?.label || String(id || '');
}

export function levelLabel(l) {
  return String(l || '').replace(/^\w/, (c) => c.toUpperCase());
}

/** Creator de la API → forma que usan las tarjetas de entrenador. */
export function creatorToTrainer(c) {
  const specialty = (c.disciplines || []).map(disciplineLabel).join(' · ');
  return {
    id: c.id,
    label: c.display_name,
    logo: c.avatar_url
      || `https://ui-avatars.com/api/?name=${encodeURIComponent(c.display_name || 'FL')}&background=1c1917&color=d4ff3f&size=128&bold=true&format=png`,
    caption: specialty,
    bio: c.bio || '',
    specialty,
    isNew: c.is_new === true,
    classesPublished: c.classes_published || 0,
  };
}

function weekdayOf(fecha) {
  const t = Date.parse(`${fecha}T12:00:00`);
  return Number.isFinite(t) ? new Date(t).getDay() : null;
}

function todayIso() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** Clases en vivo con fecha desde hoy → franjas por día de la semana. */
export function scheduleFromClasses(classes = []) {
  const today = todayIso();
  return classes
    .filter((c) => c.tipo !== 'replay' && c.fecha && c.fecha >= today)
    .map((c) => ({
      day: weekdayOf(c.fecha),
      time: c.hora || '',
      title: c.title,
      duration: c.duration_min,
      level: levelLabel(c.level),
      tokens: c.price_tokens,
      classId: c.id,
      creatorId: c.creator_id,
      creatorName: c.creator_name,
    }))
    .filter((s) => s.day != null);
}

export function weekColumns(slots = []) {
  return WEEK_ORDER.map((day) => ({
    day,
    slots: slots.filter((s) => s.day === day).sort((a, b) => String(a.time).localeCompare(String(b.time))),
  }));
}

/** Clase de la API → forma de `FitLiveClassDetail`. */
export function classToPreview(c) {
  const freeReplay = c.free_replay === true || Number(c.price_tokens) === 0;
  return {
    id: c.id,
    trainerId: c.creator_id,
    title: c.title,
    level: levelLabel(c.level),
    discipline: disciplineLabel(c.discipline),
    coach: c.creator_name,
    duration: c.duration_min,
    tokens: freeReplay ? 0 : c.price_tokens,
    freeReplay,
    tipo: c.tipo || 'vivo',
    isReplay: String(c.tipo || '').toLowerCase() === 'replay',
    when: c.fecha && c.hora ? `${c.fecha} · ${c.hora}` : '',
    aired: c.fecha ? `${c.fecha}${c.hora ? ` · ${c.hora}` : ''}` : `${c.duration_min || 0} min`,
    blurb: c.description || '',
    image: c.image_url || DEFAULT_CLASS_IMAGE,
  };
}

export function waUrl(phone, text) {
  const digits = String(phone || '').replace(/\D/g, '');
  if (!digits) return '';
  const q = text ? `?text=${encodeURIComponent(text)}` : '';
  return `https://wa.me/${digits}${q}`;
}
